import React from "react";

import Paper from "@material-ui/core/Paper";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import Skeleton from "@material-ui/lab/Skeleton";

import { makeStyles } from "@material-ui/core/styles";

import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';

import Rating from '@material-ui/lab/Rating';
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(theme => ({
    on: {
        color: '#D4AF37',
        fontSize: '18px',
        filter: 'drop-shadow(0 2px 5px rgba(212,175,55,.28))'
    },
    off: {
        color: '#98A2B3',
        fontSize: '18px'
    },
    pointer: {
        cursor: "pointer"
    },
    container: { borderRadius: 0, boxShadow: 'none', background: 'transparent' },
    table: { minWidth: 760 },
    headCell: { background: '#F7F2E3', color: '#5B4B1D', fontSize: 10.5, fontWeight: 800, letterSpacing: '.65px', textTransform: 'uppercase', paddingTop: 15, paddingBottom: 15, borderBottom: '1px solid #DED1A6', whiteSpace: 'nowrap' },
    row: { transition: 'background .18s ease', '&:hover': { background: '#FBF7EA' }, '&:last-child td': { borderBottom: 0 } },
    cell: { color: '#344054', fontSize: 13, borderBottom: '1px solid #EEE7D4', paddingTop: 15, paddingBottom: 15 },
    nameCell: { display: 'flex', alignItems: 'center', gap: 11, fontWeight: 750, color: '#101828' },
    avatar: { width: 32, height: 32, flex: '0 0 32px', borderRadius: 10, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: '#2A210B', background: 'linear-gradient(135deg,#F8E7A8,#D4AF37)', fontSize: 12, fontWeight: 900, textTransform: 'uppercase' },
    numeric: { fontWeight: 750, color: '#101828', fontVariantNumeric: 'tabular-nums' },
    ratingBadge: { display: 'inline-flex', minWidth: 36, height: 26, padding: '0 9px', alignItems: 'center', justifyContent: 'center', borderRadius: 8, color: '#755600', background: '#FBF2D4', fontWeight: 850 },
    statusPill: { display: 'inline-flex', alignItems: 'center', gap: 6, padding: '5px 9px', borderRadius: 99, fontSize: 11, fontWeight: 800 },
    statusOnline: { color: '#755600', background: '#FBF2D4' },
    statusOffline: { color: '#667085', background: '#F2F4F7' },
}));

export function RatingBox({ rating }) {
    const ratingTrunc = rating === null ? 0 : Math.trunc(rating);
    return <Rating
        defaultValue={ratingTrunc}
        max={3}
        readOnly
    />
}

export default function TableAttendantsStatus(props) {
    const { loading, attendants, rankingLoading, userRatingEnabled } = props
    const classes = useStyles();

    function renderList() {
        return attendants.map((a, k) => (
            <TableRow key={k} className={classes.row}>
                <TableCell className={classes.cell}>
                    <div className={classes.nameCell}>
                        <span className={classes.avatar}>{(a.name || '?').trim().charAt(0)}</span>
                        <span>{a.name}</span>
                    </div>
                </TableCell>
                {/* <TableCell align="center" title="1 - Insatisfeito, 2 - Satisfeito, 3 - Muito Satisfeito" className={classes.pointer}>
                    <RatingBox rating={a.rating} />
                </TableCell> */}
                {userRatingEnabled && (
                    <TableCell align="center" className={classes.cell}><span className={classes.ratingBadge}>{a.rating}</span></TableCell>
                )}
                {userRatingEnabled && (
                    <TableCell align="center" className={`${classes.cell} ${classes.numeric}`}>{a.countRating}</TableCell>
                )}
                <TableCell align="center" className={`${classes.cell} ${classes.numeric}`}>{a.tickets}</TableCell>
                <TableCell align="center" className={`${classes.cell} ${classes.numeric}`}>{rankingLoading ? '…' : formatMinutesShort(a.avgStartMinutes)}</TableCell>
                <TableCell align="center" className={`${classes.cell} ${classes.numeric}`}>{rankingLoading ? '…' : formatMinutesShort(a.avgResponseMinutes)}</TableCell>
                <TableCell align="center" className={classes.cell}>
                    {a.online ?
                        <Tooltip title="Online">
                            <span className={`${classes.statusPill} ${classes.statusOnline}`}><CheckCircleIcon className={classes.on} /> Online</span>
                        </Tooltip>
                        :
                        <Tooltip title="Offline">
                            <span className={`${classes.statusPill} ${classes.statusOffline}`}><ErrorIcon className={classes.off} /> Offline</span>
                        </Tooltip>
                    }
                </TableCell>
            </TableRow>
        ))
    }

    function formatMinutesShort(minutes) {
        if (minutes === undefined || minutes === null) return '-';
        const m = Number(minutes);
        if (!isFinite(m) || m <= 0) return '-';
        if (m < 60) return `${m.toFixed(1)}min`;
        const h = Math.floor(m / 60);
        const rem = Math.round(m % 60);
        return `${h}h ${rem}m`;
    }

    return (!loading ?
        <TableContainer component={Paper} elevation={0} className={classes.container}>
            <Table className={classes.table}>
                <TableHead>
                    <TableRow>
                        <TableCell className={classes.headCell}>{i18n.t("dashboard.users.name")}</TableCell>
                        {userRatingEnabled && (
                            <TableCell align="center" className={classes.headCell}>{i18n.t("dashboard.assessments.score")}</TableCell>
                        )}
                        {userRatingEnabled && (
                            <TableCell align="center" className={classes.headCell}>{i18n.t("dashboard.assessments.ratedCalls")}</TableCell>
                        )}
                        <TableCell align="center" className={classes.headCell}>{i18n.t("dashboard.assessments.totalCalls")}</TableCell>
                        <TableCell align="center" className={classes.headCell}>Média iniciar</TableCell>
                        <TableCell align="center" className={classes.headCell}>Média resposta</TableCell>
                        <TableCell align="center" className={classes.headCell}>{i18n.t("dashboard.cards.status")}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {renderList()}
                </TableBody>
            </Table>
        </TableContainer>
        : <Skeleton variant="rect" height={150} />
    )
}
